import { AddItemToCartResult } from '@/models/cart/command/add-item-to-cart'
import { EcommerceItem } from './ecommerce-item'

/**
 * @see https://developers.google.com/analytics/devguides/collection/ga4/reference/events?sjid=1228647551205989991-NC&hl=ja&client_type=gtm#add_to_cart
 */
export interface AddToCartEvent {
  event: 'add_to_cart'
  ecommerce: {
    currency: 'JPY',
    value: number,
    items: EcommerceItem[]
  }
}

const createFromAddItemToCartResults = (results: AddItemToCartResult[]): AddToCartEvent => {
  const totalPrice = results.reduce(
    (acc, i) => acc + i.price.prices.selected.price * i.count,
    0
  )

  return {
    event: 'add_to_cart',
    ecommerce: {
      currency: 'JPY',
      value: totalPrice,
      items: results.map(r => ({
        item_id: r.productId,
        item_name: r.productNameLabel,
        item_variant: r.productColorLabel,
        price: r.price.prices.selected.price,
        quantity: r.count,
      })),
    },
  }
}

export const addToCartEventFactory = {
  createFromAddItemToCartResults,
} as const
